import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Layout from './components/layout/layout';
import HomePage from './pages/HomePage';
import PostDetailPage from './pages/PostDetailPage';
import CategoryPage from './pages/CategoryPage';
import ContactPage from './pages/ContactPage';
import SearchPage from './pages/SearchPage';

// Import the hook we discussed
import useAnalytics from './hooks/useAnalytics';

// 1. Create a wrapper to execute the hook
function AnalyticsHandler() {
  useAnalytics();
  return null; // This component doesn't render anything
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        {/* 2. Place the handler here so it watches every route change */}
        <AnalyticsHandler />
        
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="post/:slug" element={<PostDetailPage />} />
            <Route path="/category/:slug" element={<CategoryPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/search" element={<SearchPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;